import React from 'react';
import { Image } from '@colonist/ui';
import IconGiftBox from '@static/images/icon_gift_box.svg';
import styles from './ActionCell.module.scss';
/** Gift button for a friend row. */ export const ActionCell = ({ userId, username, onGiftClick })=>{
    const handleGiftClick = (event)=>{
        event.stopPropagation();
        onGiftClick(userId, username);
    };
    return(// TODO: Muhammad - Convert to IconButton
    /*#__PURE__*/ React.createElement("div", {
        className: styles.giftButton,
        "data-testid": "profile-friend-gift-button",
        onClick: handleGiftClick
    }, /*#__PURE__*/ React.createElement(Image, {
        image: {
            src: IconGiftBox,
            alt: 'strings:storePage.sections.giftOverlay.tierSelection.buttonTitle'
        }
    })));
};
